import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AppSettings from "../../../Settings/AppSettings";
import AuthManager from "../../../Common/AuthManager";
import { AppContext } from "../../../Context/AppContext";
import { AttributeContext } from "./AttributeContext";
import AttributeValues from "./Componets/AttributeValues";
import ABS from "./Componets/ABS";
import AttributeConstraint from "./Componets/AttributeConstraint";
import Category from "./Componets/Category";
import { toast } from "Components/DesignSystem/Toast/useToast";
import Utils from "../../../Common/Utils";
import { getAbsConstraintsByAttributeID, getAssociatedCategoriesByAttributeID, getConstraintsByAttributeID, listAttributeValuesByAttributeID } from "api/Attributes";

import LoadingSuccessErrorAlert from "./Componets/LoadingSuccessErrorAlert";
import AttributeDetails from "./Componets/AttributeDetails";
import { generateAttributeConstraintObject } from "./constants";
import { ABS_SELECTION } from "./AttributeConstants";
import Card from "Components/DesignSystem/Card/Card";
import Typography from "Components/DesignSystem/Typography/Typography";
import Button from "Components/DesignSystem/Button/Button";
import TextField from "Components/DesignSystem/TextField/TextField";
import Textarea from "Components/DesignSystem/Textarea/Textarea";
import Checkbox from "Components/DesignSystem/Checkbox/Checkbox";
import InfoTooltip from "Components/DesignSystem/Tooltip/InfoTooltip";
import { CUSTOM_ATTRIBUTE_CHECKBOX_LABEL, CUSTOM_ATTRIBUTE_TOOLTIP } from "Common/CustomAttribute";
import Skeleton from "Components/DesignSystem/Skeleton/Skeleton";

// let disableButton = false;
function AddEditViewAttr({ setAttrListApiCompleted }) {
  const appContext = useContext(AppContext);
  const attributeContextData = useContext(AttributeContext);
  const industryId =
    appContext.get_selected_industry() && appContext.get_selected_industry().id;

  const [finalAttributeConstraint, setFinalAttributeConstraint] =
    useState(null);
  const [finalAttributeValues, setFinalAttributeValues] = useState([]);
  const [finalABSValue, setFinalABSValue] = useState(null);
  const [finalCFValue, setFinalCFValue] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [prevSelectedCategory, setPrevSelectedCategory] = useState([]);
  const [associatedCategory, setAssociatedCategory] = useState(null);
  const [attributeResponse, setAttributeResponse] = useState(null);
  const [disableButtons, setDisableButtons] = useState(true);

  const { editingItem, setListReloadCounter, setEditingItem, attributeId } = useContext(AttributeContext);
  const [loading, setLoading] = useState({ status: "", message: "", });
  const [loadingInfo, setLoadingInfo] = React.useState({ status: "", message: "", });

  // is_custom defaults unchecked (AB#14524 AC 4); on edit it is pre-populated from the
  // GET response, which projects the node's coalesce(a.is_custom, false).
  const initialStateObject = { id: "", name: "", description: "", active: true, is_custom: false, };
  const validationOptions = { name: { required: true, minLength: 2, maxLength: 60, type: "alnum_with_spaces_dots", }, };
  const [nameError, setNameError] = useState("");
  const [attributeDetail, setAttributeDetail] = useState(initialStateObject);
  const [attributeDetailCopy, setAttributeDetailCopy] = useState(initialStateObject);

  async function load_attribute_detail() {
    setAttributeResponse(null);
    setLoadingInfo({ status: "", message: "", });
    setLoading({ status: "Loading", message: "Loading Attribute Details", });
    // Blocks list selection while this is in flight -- see AttrList's row onClick.
    attributeContextData.setDetailLoading(true);
    const api_base_url = AppSettings.GMS_BACKEND_API_URL;
    const res = await ServiceWrapper.doGet(
      `${api_base_url}industry/${industryId}/attribute/list/${editingItem.id}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (editingItem.form === "duplicate") {
        res.data.data[0].name = "[Duplicate] " + res.data.data[0].name;
        res.data.data[0].description =
          "[Duplicate] " + res.data.data[0].description;
        await setAttributeDetail(res.data.data[0]);
        await setAttributeDetailCopy(res.data.data[0]);
      } else {
        await setAttributeDetail(res.data.data[0]);
        await setAttributeDetailCopy(res.data.data[0]);
      }
      if (
        res.data.data[0].attribute_value &&
        res.data.data[0].attribute_value.data
      ) {
        setFinalAttributeValues(res.data.data[0].attribute_value.data);
      }
      const attributeValue = {
        ...res.data.data[0],
        associated_category: {},
        abs_constraints: {},
        attribute_value: {},
        constraints: {},
      }
      attributeValue.associated_category.data = await getAssociatedCategoriesByAttributeID(editingItem.id)
      const absConstraints = await getAbsConstraintsByAttributeID(editingItem.id, 10, undefined, undefined)
      attributeValue.abs_constraints.data = absConstraints.constraints
      const { attribute_values, count } = (await listAttributeValuesByAttributeID(editingItem.id, 10, undefined, undefined))
      attributeValue.attribute_value.data = attribute_values
      attributeValue.attribute_value_count = count
      attributeValue.constraints.data = generateAttributeConstraintObject(await getConstraintsByAttributeID(editingItem.id))
      if (attributeValue.abs_constraints.data.abs_enabled == null) {
        attributeValue.abs_constraints.data.abs_enabled = false
      }
      setAttributeDetail(attributeValue);
      setAttributeDetailCopy(attributeValue);
      setFinalAttributeConstraint(attributeValue.constraints.data)

      // setDisableButtons(true);
      setLoading({
        status: "Success",
        message: undefined,
      });
      attributeContextData.setDetailLoading(false);
    } else {
      setLoading({
        status: "Error",
        message: "Error while fetching details, Please try after some time.",
      });
      attributeContextData.setDetailLoading(false);
    }
  }

  useEffect(() => {
    const validation = Utils.validate(attributeDetail, validationOptions);
    const { abs_constraints, constraints } = attributeDetail;

    // validation check for disabling save button
    if (
      !validation[0] ||
      (JSON.stringify(prevSelectedCategory) ===
        JSON.stringify(selectedCategory) &&
        JSON.stringify(attributeDetail) ===
        JSON.stringify(attributeDetailCopy) &&
        (finalABSValue === null ||
          JSON.stringify(abs_constraints?.data) ===
          JSON.stringify(finalABSValue)) &&
        finalAttributeValues.length === 0 &&
        constraints?.data &&
        JSON.stringify(constraints.data) ===
        JSON.stringify(finalAttributeConstraint))
    ) {
      setDisableButtons(true);
    } else {
      setDisableButtons(false);
    }

    if (finalABSValue) {
      // setDisableButtons(false);
    }

    if (finalAttributeValues) {
      // setDisableButtons(false);
    }

    if (selectedCategory) {
      // setDisableButtons(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributeDetail, finalABSValue, finalAttributeValues, selectedCategory]);

  async function hande_change(e) {
    let temp = JSON.parse(JSON.stringify(attributeDetail));

    temp[e.target.name] =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setAttributeDetail(temp);

    if (e.target.name === "name") {
      const validation = Utils.validate(temp, validationOptions);
      setNameError(!validation[0] ? validation[1] : "");
    }
  }

  async function save_changes() {
    setAttributeResponse(null);
    setDisableButtons(true);

    setLoadingInfo({
      status: "Saving",
      message: "Saving changes",
    });

    let api_base_url = AppSettings.GMS_BACKEND_API_URL;

    let final_url = `${api_base_url}attribute/edit/${editingItem.id}`;
    if (editingItem.id === "0" || editingItem.form === "duplicate") {
      final_url = `${api_base_url}attribute/create`;
    }
    if (finalAttributeConstraint && finalAttributeConstraint.validation_type) {
      finalAttributeConstraint.validation_type = "LOV";
    }
    attributeDetail.abs_constraints = finalABSValue;
    attributeDetail.cf_constraints = finalCFValue;
    attributeDetail.constraints = finalAttributeConstraint;
    attributeDetail.attribute_value = {
      data: finalAttributeValues,
      industry_id: industryId,
    };

    attributeDetail.industry_id = industryId;

    let newlyDeleted = [];
    let newlyAdded = [...selectedCategory];

    if (prevSelectedCategory && prevSelectedCategory.length > 0) {
      prevSelectedCategory.map((item) => {
        let index = newlyAdded.findIndex((att) => att.id === item.id);
        if (index === -1) {
          let { id } = item;
          newlyDeleted.push({ id });
        } else {
          newlyAdded.splice(index, 1);
        }
        return null;
      });
    }

    let newIds = newlyAdded.map((a) => a.id);
    let deletedIds = newlyDeleted.map((a) => a.id);
    let data = {
      delete_category: deletedIds,
      add_category: newIds,
      industry_id: industryId,
    };
    attributeDetail.associated_category = data;

    let final_details = {
      ...attributeDetail,
      // Always a real boolean: the backend rejects anything else with
      // "Custom Attribute Flag Should Be Boolean", and an edit that omits the key
      // un-marks the attribute (full-replace, like description) -- so send it explicitly.
      is_custom: attributeDetail.is_custom === true,
    };

    let res = await ServiceWrapper.doPost(
      final_url,
      final_details,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      setAttributeResponse(res.data);
      if (!res.data.done) {
        toast.error(res.data.error_message);
        setTimeout(() => {
          if (editingItem.id !== "0") {
            setEditingItem({
              form: "view",
              id: attributeDetail.id,
            });
          }
          setDisableButtons(false);
        }, 2000);

        return;
      }
      handleResponseMessages(res.data);

      if (editingItem.id === "0" || editingItem.form === "duplicate") {
        setAttributeDetail(initialStateObject);
        setAttributeDetailCopy(initialStateObject);
        setDisableButtons(false);
        attributeContextData.setNewAttributeId(res?.data?.id ?? "");
        handle_reload_list(res?.data?.id);
      } else {
        setTimeout(() => {
          editingItem.id === "0"
            ? setEditingItem(null)
            : setEditingItem({
              form: "view",
              id: attributeDetail.id,
            });
          setDisableButtons(false);
        }, 2000);
        attributeContextData.setUpdatedAttributeId(attributeDetail?.id ?? "");
        setAttributeDetailCopy(attributeDetail);
        handle_reload_list(attributeDetail.id);
      }
    } else {
      toast.error("Something went wrong, Please try after some time.");
      setTimeout(() => {
        if (editingItem.id !== "0") {
          setEditingItem({
            form: "view",
            id: attributeDetail.id,
          });
        }
        setDisableButtons(false);
      }, 2000);
    }
    setLoadingInfo({
      status: "",
      message: "",
    });
  }

  function handleResponseMessages(response) {
    let attributeValue = response.attribute_value;
    let constraints = response.constraints;
    let absConstraints = response.abs_constraints;
    let associatedCategory = response.associated_category;
    let error_flag = false;
    if (attributeValue) {
      if (!attributeValue.done) {
        toast.error(attributeValue.error_message);
        error_flag = true;
      }
    }

    if (constraints) {
      if (!constraints.done) {
        toast.error(constraints.error_message);
        error_flag = true;
      }
    }

    if (absConstraints) {
      if (!absConstraints.done) {
        toast.error(absConstraints.error_message);
        error_flag = true;
      }
    }

    if (associatedCategory) {
      if (!associatedCategory.done) {
        toast.error(associatedCategory.error_message);
        error_flag = true;
      }
    }
    if (!error_flag) {
      if (editingItem.id === "0" || editingItem.form === "duplicate") {
        toast.success("Attribute Created Successfully");
      } else {
        toast.success("Attribute Updated Successfully");
      }
    }
  }

  function handle_reload_list(id) {
    // if (
    //   !(
    //     attributeDetail.name === attributeDetailCopy.name &&
    //     attributeDetail.active === attributeDetailCopy.active
    //   )
    // ) {

    // }
    setListReloadCounter((n) => n + 1);
    setTimeout(() => {
      attributeContextData.setEditingItem({
        form: "view",
        id: id,
      });
    }, 1000);
  }

  useEffect(() => {
    setNameError("");
    if (editingItem.form === "edit" || editingItem.form === "duplicate") {
      if (editingItem.id === "0") {
        setAttributeDetail(initialStateObject);
        setAttributeDetailCopy(initialStateObject);
      } else {
        load_attribute_detail();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem]);

  useEffect(() => {
    setNameError("");
    if (editingItem.id === "0") {
      setAttributeDetail(initialStateObject);
      setAttributeDetailCopy(initialStateObject);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem.id]);

  const handleOnSaveClick = () => {
    const validation = Utils.validate(attributeDetail, validationOptions);
    if (!validation[0]) {
      setNameError(validation[1]);
      toast.error(validation[1]);
      return;
    }

    if (appContext.pm.checkPermission("gmsattributes_update")) {
      save_changes();
    } else {
      toast.info("You do not have permission to save the attributes");
    }
  }

  const handleOnCancelClick = () => {
    editingItem.id === "0" ? setEditingItem({ form: "view", id: attributeId, }) : setEditingItem({ form: "view", id: attributeDetail.id, });
  }

  return (
    <React.Fragment>
      {editingItem.form === "view" ? (
        <AttributeDetails
          attributeResponse={attributeResponse}
          setAttrListApiCompleted={setAttrListApiCompleted}
        />
      ) : (
        <>
          {loading.status === "Loading" && (
            <div className="p-3 ms-3 tw-space-y-4" data-testid="attribute-edit-skeleton">
              <Skeleton variant="rect" width="25%" height="20px" />
              <div className="p-3 tw-border tw-border-edge tw-rounded-ctl tw-space-y-4">
                <div className="tw-flex tw-justify-between">
                  <Skeleton variant="rect" width="30%" height="24px" />
                  <Skeleton variant="rect" width="15%" height="24px" />
                </div>
                <Skeleton variant="rect" width="50%" height="36px" />
                <Skeleton variant="rect" width="50%" height="96px" />
              </div>
              <Skeleton variant="rect" width="92%" height="40px" />
              <Skeleton variant="rect" width="92%" height="40px" />
              <Skeleton variant="rect" width="92%" height="40px" />
              <Skeleton variant="rect" width="92%" height="40px" />
            </div>
          )}

          {loading.status !== "Loading" && (
            <>
              {/* No `bg-body`: it is Bootstrap's light-only white and painted the
                  gutters white around the dark cards (user-reported 2026-09-01).
                  The page ground comes from the app shell's themed surface. */}
              <div className="pt-1 mb-3 ps-3">
                <Card className="tw-mb-4 me-3">
                  {/* Divider between the title/actions row and the form fields
                      (user-suggested 2026-09-01) — same grammar as the page
                      header's bottom border. */}
                  <div
                    className="d-flex justify-content-between tw-pb-3 tw-border-b tw-border-edge"
                    data-testid="attribute-edit-header"
                  >
                    <div>
                      <Typography variant="display" as="h1" className="tw-mb-0 tw-text-ink">
                        {`${editingItem.id === "0"
                            ? "Create "
                            : `${editingItem.form === "duplicate"
                              ? "Duplicate "
                              : "Edit"
                            }`
                          } Attribute`}
                      </Typography>
                      {editingItem.id !== "0" && (
                        <Typography variant="caption-metadata" as="p" className="tw-mt-1 tw-mb-0 tw-text-ink-secondary">
                          {`UID: ${editingItem.id !== "0" ? editingItem.id : ""}`}
                        </Typography>
                      )}
                    </div>
                    <div className="tw-flex tw-items-start tw-gap-3">
                      <Button variant="secondary" size="sm" onClick={handleOnCancelClick} data-testid="attribute-cancel-btn">Cancel</Button>
                      {/* disabled={disableButtons} */}
                      <Button variant="primary" size="sm" onClick={handleOnSaveClick} data-testid="attribute-save-btn">Save</Button>
                    </div>
                  </div>
                  <form className="tw-mt-4 tw-space-y-4">
                    <div className="col-7">
                      <TextField
                        label="Name"
                        size="sm"
                        type="text"
                        id="name"
                        name="name"
                        data-testid="attribute-addeditviewattr-input-1"
                        placeholder="Enter Attribute Name"
                        value={attributeDetail.name}
                        onChange={(value) =>
                          hande_change({
                            target: { name: "name", type: "text", value },
                          })
                        }
                        error={!!nameError}
                        helperText={
                          nameError ||
                          "Name must be 2-60 characters long. Allowed characters: letters, numbers, spaces, and these symbols: & / () [] % - _ ."
                        }
                        maxLength={60}
                        minLength={2}
                      />
                    </div>

                    <div className="col-7">
                      <Textarea
                        label="Description"
                        id="description"
                        name="description"
                        data-testid="attribute-addeditviewattr-textarea-2"
                        rows={5}
                        placeholder="Enter description"
                        value={attributeDetail.description}
                        onChange={(value) =>
                          hande_change({
                            target: { name: "description", type: "textarea", value },
                          })
                        }
                      />
                    </div>

                    {/* AB#14524: directly below Description, identical to the shared
                        CreateAttributeModal used by Data Review + Data Mapping. */}
                    <div className="col-7 tw-flex tw-items-center tw-gap-2">
                      <Checkbox
                        label={CUSTOM_ATTRIBUTE_CHECKBOX_LABEL}
                        size="sm"
                        checked={attributeDetail.is_custom === true}
                        onChange={(checked) =>
                          hande_change({
                            target: { name: "is_custom", type: "checkbox", checked },
                          })
                        }
                        data-testid="attribute-addeditviewattr-custom-checkbox"
                      />
                      <InfoTooltip
                        placement="top"
                        message={CUSTOM_ATTRIBUTE_TOOLTIP}
                        data-testid="attribute-addeditviewattr-custom-info"
                      />
                    </div>
                  </form>
                </Card>
                <div className="me-3">
                  <Category
                    existingCategory={
                      attributeDetail.associated_category === undefined
                        ? []
                        : attributeDetail.associated_category.data
                    }
                    attributeId={editingItem.id === "0" ? null : editingItem.id}
                    setSelectedCategory={setSelectedCategory}
                    setAssociatedCategory={setAssociatedCategory}
                    setPrevSelectedCategory={setPrevSelectedCategory}
                    saveMessage={
                      attributeResponse &&
                      attributeResponse.associated_category &&
                      attributeResponse.associated_category.done
                    }
                  />
                </div>
                <br />
                <div className="me-3">
                  <AttributeValues
                    aDetail={attributeDetail.attribute_value}
                    finalAttributeValues={finalAttributeValues}
                    setFinalAttributeValues={setFinalAttributeValues}
                    attributeValueCount={attributeDetail.attribute_value_count}
                    saveMessage={
                      attributeResponse &&
                      attributeResponse.attribute_value &&
                      attributeResponse.attribute_value.done
                    }
                  />
                </div>
                <br />
                <div className="me-3">
                  {editingItem.id !== "0" ? (
                    <ABS
                      finalABSValue={finalABSValue}
                      setFinalABSValue={setFinalABSValue}
                      setFinalCFValue={setFinalCFValue}
                      attributeValueCount={attributeDetail.attribute_value_count}
                      title={ABS_SELECTION}
                      id="Abs"
                    />
                  ) :
                    null
                  }
                </div>
                {editingItem.id !== "0" && <br />}
                <div className="me-3">
                  <AttributeConstraint
                    finalattributeConstraint={finalAttributeConstraint}
                    setFinalAttributeConstraint={setFinalAttributeConstraint}
                    constraintModel={
                      attributeDetail.constraints &&
                      attributeDetail.constraints.data
                    }
                    saveMessage={
                      attributeResponse &&
                      attributeResponse.constraints &&
                      attributeResponse.constraints.done
                    }
                  />
                </div>
                {/* Collection Filtering tab hidden
                {editingItem.id !== "0" && <br />}
                <div className="me-3">
                  {editingItem.id !== "0" ? (
                    <ABS
                      finalCFValue={finalCFValue}
                      setFinalABSValue={setFinalABSValue}
                      setFinalCFValue={setFinalCFValue}
                      attributeValueCount={attributeDetail.attribute_value_count}
                      title={CF_SELECTION}
                      id="Cf"
                    />
                  ) :
                    null
                  }
                </div>
                */}
                <div className="float-start">
                  <LoadingSuccessErrorAlert loading={loadingInfo} data-testid="attribute-edit-status" />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </React.Fragment>
  );
}

export default AddEditViewAttr;